import React from "react";
import { Helmet } from "react-helmet";
import markdownContent from "./content/TermsOfService.md?raw";
import MarkdownPage from "../core/MarkdownPage";

export default function TermsOfService() {
  return (
    <>
      <Helmet>
        <title>Data FabrIQ Terms of Service</title>
        <meta
          name="description"
          content="Data FabrIQ terms of service follow industry best practices."
        />
      </Helmet>
      <MarkdownPage content={markdownContent} />
    </>
  );
}
